import styled from "@emotion/styled";
import isPropValid from '@emotion/is-prop-valid';
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";

export const Content = styled.div`
    display:grid;
    grid-template-rows: 50px 1fr;
    height:100%;
    
    ${mq(Devices.mobile)}{
        max-height: unset;
    }
`;

export const StudentListTop = styled.div<{scroll?:boolean}>`
    display:flex;
    align-items: center;
    height:50px;
    padding-right: ${props => props.scroll?"10px":"0"};

    ${mq(Devices.mobile)}{
        padding-right: 0 ;
    }
`;

export const ShowAll = styled.button`
    margin-left: auto;
    background: ${props => props.theme.colors.placeholderColor};
    font-size: 16px;
    color:#fff;
    border-radius:20px;
    padding:6px 24px;
    transition: all 0.2s ease-in-out;

    :hover{
        background: ${props => props.theme.colors.buttonHoverColor}
    }
`;

export const Container = styled.div<{scroll?:boolean}>`
    width:100%;
    padding-right: ${props => props.scroll?"3px":"0"};
    min-height: ${props => props.scroll?"368px":"130px"};
    height: ${props => props.scroll?"100%":""};
    max-height: ${props => props.scroll?"368px":""};
    overflow-y:  ${props => props.scroll?"auto":""};
    display: flex;
    flex-direction: column;
    gap:16px;
    margin-top: 10px;

    ::-webkit-scrollbar{
        width:7px;
        height:100%;
    }
    ::-webkit-scrollbar-thumb{
        background:#85858583;
        border-radius: 4px;
    }
    ::-webkit-scrollbar-track{
        
    } 

    
    ${mq(Devices.mobile)}{
        max-height: unset;
    }
`;

export const Item = styled.div`
    display: grid;
    grid-template-columns:  1fr 90px;
    background: ${props => props.theme.colors.offWhite};
    min-height: 80px;
    width:100%;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;

    ${mq(Devices.mobile)}{
        grid-template-columns: 1fr 80px;
        height: 60px;
    }
`;

export const Info = styled.div`
    position: relative;
    display: grid;
    grid-template-columns: 90px 1fr 96px;
    height:100%;
    align-items: center;

    ${mq(Devices.mobile)}{
        grid-template-columns: 70px 1fr 76px;
    }
`;

export const StudentImage = styled.div`
    position: relative;
    height:100%;
`;

export const StudentInfo = styled.div`
    height:100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding:8px 10px;

    span{
        font-size: 18px;
        font-weight: 500;
    }

    ${mq(Devices.mobile)}{
        span{
            font-weight: 500;
            font-size: clamp(12px, 3.5vw , 16px);
        }  
    }
`;

export const StudentOptions = styled.div`
    height:100%;
    display:flex;
    align-items: center;
    justify-content: end;
    gap:10px;

    div {
      height:100%;
      display:flex;
      align-items: center;
      justify-content: end;
    }

    ${mq(Devices.mobile)}{
        gap:0;
    }
`;

export const OptionButton = styled('button', {
    shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'display',
})<{active?:boolean, display?:boolean}>`
    background:#959595;
    height:60%;
    aspect-ratio: 1 /1 ;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    opacity: ${props => props.active?"1":"0.3"};
    transition: all 0.2s ease-in-out;
    display: ${props => props.display?"unset":"none"};

    svg{
        height:55%;
    }

    :hover{
        background:#959595;
        opacity: 1;
    }


    ${mq(Devices.mobile)}{
        height:50%;


        :nth-of-type(2){
            display:none;
        } 


    }
`;

export const Percentage = styled.div<{backgroundType?:string}>`
    background: ${props => props.backgroundType};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 800;
    color:#fff;

    ${mq(Devices.mobile)}{

    }
`;


